/**
 * Route for `real-time-event-alerts-module`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RealTimeEventAlertsModulePage } from "../features/real-time-event-alerts-module/RealTimeEventAlertsModulePage";

export const realTimeEventAlertsModuleRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/real-time-event-alerts-module",
	component: RealTimeEventAlertsModulePage,
});

export default realTimeEventAlertsModuleRoute;
